(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-bar')) {
    customElements.define(
      'announcement-bar',
      class AnnouncementBar extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.announcement-bar__track');
          this.source = this.querySelector('.announcement-bar__group');
          this.sync = this.sync.bind(this);
          this.sync();

          this.resizeObserver = new ResizeObserver(this.sync);
          this.resizeObserver.observe(this);
          if (this.source) this.resizeObserver.observe(this.source);
          document.fonts?.ready.then(this.sync);
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        createClone() {
          const clone = this.source.cloneNode(true);
          clone.classList.add('announcement-bar__group--clone');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => {
            node.removeAttribute('data-shopify-editor-block');
          });
          return clone;
        }

        sync() {
          if (!this.track || !this.source) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          const groupWidth = this.source.offsetWidth;
          const viewportWidth = this.offsetWidth;
          if (groupWidth === 0) return;

          const needed = Math.max(2, Math.ceil((viewportWidth * 2) / groupWidth));
          let count = this.track.querySelectorAll('.announcement-bar__group').length;
          while (count < needed) {
            this.track.appendChild(this.createClone());
            count += 1;
          }

          this.track.style.setProperty('--ab-scroll-distance', `-${groupWidth}px`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.syncOverlay = this.syncOverlay.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = this.classList.contains('header-wrapper') ? this : this.querySelector('.header-wrapper');
      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight);
      if (this.header) this.header.classList.add('shopify-section-header-sticky');
      window.addEventListener('scroll', this.syncOverlay, { passive: true });
      this.bindOverlay();
    }

    bindOverlay() {
      const start = () => {
        this.hero = document.querySelector('.homepage-hero');
        this.syncOverlay();
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
      } else {
        start();
      }
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.syncOverlay();
    }

    solidScrollPercent() {
      const value = Number(this.dataset.solidScrollPercent);
      if (Number.isNaN(value)) return 100;
      return Math.min(100, Math.max(0, value));
    }

    syncOverlay() {
      if (!this.headerWrapper) return;
      if (!this.hero) {
        this.headerWrapper.classList.remove('header-wrapper--solid');
        return;
      }

      const headerBottom = this.headerWrapper.getBoundingClientRect().bottom;
      const heroRect = this.hero.getBoundingClientRect();
      const heroHeight = Math.max(heroRect.height, 1);
      const scrolledRatio = (headerBottom - heroRect.top) / heroHeight;
      const threshold = this.solidScrollPercent() / 100;

      this.headerWrapper.classList.toggle('header-wrapper--solid', scrolledRatio >= threshold);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.setHeaderHeight);
      window.removeEventListener('scroll', this.syncOverlay);
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
